import { user, userReducer } from './user';
import { pipeline, pipelineReducer } from './pipeline';
import { token, tokenReducer } from './token';
import { company, companyReducer } from './company';
import { debugAction } from '../utils';

export const initialState = {
  user,
  token,
  pipeline,
  company
};

export function combinedReducers(state = initialState, action) {
  debugAction(action);
  return {
    ...state,
    user: userReducer(state.user, action),
    token: tokenReducer(state.token, action),
    pipeline: pipelineReducer(state.pipeline, action),
    company: companyReducer(state.company, action)
  };
}
